import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 10px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 10px 0px;\n\n  > * {\n    padding-bottom: 0px;\n  }\n\n  * > input + label {\n    margin: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../../utils/styling/styled-components';
import { Input as DateInput } from '../../Form/FormBuilder/DateInput';
import { Input as CheckboxInput } from '../../Form/FormBuilder/CheckboxInput';
var StyledCheckboxInputContainer = styled.div(_templateObject());
var StyledDateInputContainer = styled.div(_templateObject2());

var StyledCheckboxInput = function StyledCheckboxInput(props) {
  return /*#__PURE__*/React.createElement(StyledCheckboxInputContainer, null, /*#__PURE__*/React.createElement(CheckboxInput, props));
};

var StyledDateInput = function StyledDateInput(props) {
  return /*#__PURE__*/React.createElement(StyledDateInputContainer, null, /*#__PURE__*/React.createElement(DateInput, props));
};

export { StyledCheckboxInput, StyledDateInput };